export const HOME = "/";
export const ABOUT_US = "/about-us";
export const SERVICES = "/services";
export const PRODUCTS = "/products";
export const CONTACT_US = "/contact-us";
export const DASHBOARD = "/dashboard";
